
import { JobKanbanWrapper } from "./kanban/JobKanbanWrapper";

interface JobKanbanProps {
  jobId: string | undefined;
  skills?: string[];
}

export const JobKanban = ({ jobId, skills = [] }: JobKanbanProps) => {
  return <JobKanbanWrapper jobId={jobId} jobSkills={skills} />;
};
